import { disclaimerAccepted, loadSession, state } from "./state.js";
import { renderDashboard } from "./views/dashboard.js";
import { renderDisclaimer } from "./views/disclaimer.js";
import { renderLogin } from "./views/login.js";
import { renderStart } from "./views/start.js";

export type Route = "disclaimer" | "login" | "start" | "dashboard";

const root = document.getElementById("app")!;

export function navigate(route: Route) {
  root.innerHTML = "";
  switch (route) {
    case "disclaimer":
      renderDisclaimer(root);
      break;
    case "login":
      renderLogin(root);
      break;
    case "start":
      renderStart(root);
      break;
    case "dashboard":
      renderDashboard(root);
      break;
  }
}

function boot() {
  loadSession();
  if (!disclaimerAccepted()) {
    navigate("disclaimer");
  } else if (!state.session) {
    navigate("login");
  } else if (!state.data) {
    navigate("start");
  } else {
    navigate("dashboard");
  }
}

boot();
